import { z } from 'zod';

export const OutdoorBarArticleCategoryModelSchema = z.object({
    uid: z.string(),
    name: z.string(),
});

export type OutdoorBarArticleCategoryModel = z.infer<typeof OutdoorBarArticleCategoryModelSchema>;
